<template>
  <div class="py-10">
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-form
        v-on:submit.prevent="registerFarm"
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <div class="page-title">
          <div class="text-h5 font-weight-black">
            {{ $t("farm.farmRegistration") }}
          </div>
          <v-spacer></v-spacer>
          <template>
            <div class="mt-5 text-center data-drop">
              <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="
                      $router.push({ path: `/myfarm/farmlist`, query: { page: 1 } })
                    "
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    color="primary"
                    dark
                    depressed
                  >
                    {{ $t("farm.cancel") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    type="submit"
                    depressed
                  >
                    {{ $t("farm.register") }}
                  </v-btn>
                </template>
              </v-menu>
            </div>
          </template>
        </div>
        <div class="mt-2 form-section">
          <v-card class="mb-2" flat>
            <v-container fluid>
              <div class="font-weight-bold">
                {{ $t("farm.farmInformation") }}
              </div>
              <template>
                <v-row class="mt-2">
                  <!-- <v-col cols="12" sm="6" md="3">
                    <label for="text">
                      {{ $t("farm.farmerId") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span>{{ $t("farm.registration.farmID") }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="$t('farm.farmerId')"
                      outlined
                      dense
                      required
                      v-model="farm.userId"
                      readonly
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="3">
                    <label for="text">
                      {{ $t("farm.farmName") }}<span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.registration.farmName") }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      v-model="farm.farmName"
                      :placeholder="$t('farm.nameOfTheFarm')"
                      outlined
                      dense
                      required
                      :error-messages="errors.name"
                      :rules="farmRules.farmName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label for="text"
                      >{{ $t("farm.farmType")
                      }}<v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.registration.farmType") }}</span>
                      </v-tooltip></label
                    >
                    <v-select
                      v-model="farm.farmType"
                      :items="farmTypes"
                      item-text="name"
                      item-value="id"
                      :placeholder="$t('farm.farmType')"
                      outlined
                      dense
                      class="text-capitalize"
                      :error-messages="errors.farmType"
                    ></v-select>
                  </v-col>

                  <v-col
                    v-if="
                      currentUser &&
                      currentUser.userDetail &&
                      currentUser.userDetail.role == 'admin'
                    "
                    cols="12"
                    sm="6"
                    md="3"
                  >
                    <label for="text"
                      >{{ $t("farm.farmOwner") }}<span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.registration.farmOwner") }}</span>
                      </v-tooltip>
                    </label>
                    <!-- <v-text-field
                      v-model="farm.farmOwner"
                      outlined
                      dense
                      required
                      item-text="farmOwner"
                      item-value="id"
                      :placeholder="$t('farm.farmOwner')"
                      :error-messages="errors.farmOwner"
                      :rules="farmRules.farmOwner"
                    ></v-text-field> -->

                    <v-autocomplete
                      outlined
                      dense
                      v-model="farm.farmOwner"
                      :items="farmersList"
                      item-text="userName"
                      item-value="id"
                      attach
                      placeholder="Select Farm Owner"
                      :error-messages="errors.farmOwner"
                      :rules="farmRules.farmOwner"
                    >
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-content>
                            <div>
                              <v-icon style="color: #00bd73">mdi-plus</v-icon>
                              <a
                                style="text-decoration: underline"
                                @click="showAdduser"
                                >Create New Farm Owner</a
                              >
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col
                    v-if="
                      currentUser &&
                      currentUser.userDetail &&
                      currentUser.userDetail.role == 'farmer'
                    "
                    cols="12"
                    sm="6"
                    md="3"
                  >
                    <label for="text"
                      >{{ $t("farm.farmOwner") }}<span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.registration.farmOwner") }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :disabled="true"
                      v-model="farm.farmOwner"
                      outlined
                      dense
                      required
                      :placeholder="`${
                        currentUser &&
                        currentUser.userDetail &&
                        currentUser.userDetail.firstName
                      } ${
                        currentUser &&
                        currentUser.userDetail &&
                        currentUser.userDetail.lastName
                      }`"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label for="text"
                      >{{ $t("farm.ownershipType") }}<span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.registration.ownershipType") }}</span>
                      </v-tooltip>
                    </label>
                    <v-select
                      :items="ownershipTypes"
                      item-text="name"
                      item-value="id"
                      :placeholder="$t('Select')"
                      outlined
                      dense
                      v-model="farm.farmOwnershipType"
                      class="text-capitalize"
                      :error-messages="errors.farmOwnershipType"
                      :rules="farmRules.farmOwnershipType"
                    ></v-select>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-show="farm.farmOwnershipType == 'community'"
                  >
                    <label for="text"
                      >{{ $t("farm.CommunityName") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.registration.CommunityName") }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      item-text="name"
                      item-value="id"
                      :placeholder="$t('farm.CommunityName')"
                      outlined
                      dense
                      v-model="farm.communityName"
                      class="text-capitalize"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-show="farm.farmOwnershipType == 'corporate'"
                  >
                    <label for="text">{{ $t("farm.corporateName") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("farm.registration.corporateName")
                        }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      item-text="name"
                      item-value="id"
                      :placeholder="'Enter Name'"
                      outlined
                      dense
                      v-model="farm.corporateName"
                      class="text-capitalize"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-show="farm.farmOwnershipType == 'personal'"
                  >
                  </v-col> -->

                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-show="farm.farmOwnershipType == 'corporate'"
                  >
                    <label for="text">{{
                      $t("farm.corporateRegistrationNum")
                    }}
                  <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("farm.registration.corporateRegistrationNum")
                        }}</span>
                      </v-tooltip>  
                  </label>
                    <v-text-field
                      item-text="name"
                      item-value="id"
                      :placeholder="$t('#RED2871HD')"
                      outlined
                      dense
                      v-model="farm.corporateRegistrationNum"
                      class="text-capitalize"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-show="farm.farmOwnershipType == 'corporate'"
                  >
                    <label for="text">{{
                      $t("farm.corporateMailingAddress")
                    }}
                  <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("farm.registration.corporateMailingAddress")
                        }}</span>
                      </v-tooltip>    
                  </label>
                    <v-text-field
                      item-text="name"
                      item-value="id"
                      :placeholder="'Enter Mailing Address'"
                      outlined
                      dense
                      v-model="farm.corporateMailingAddress"
                      class="text-capitalize"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.govRegistrationNo") }}<span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("farm.registration.govtRegistrationNumber")
                        }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="$t('#RED2871HD')"
                      outlined
                      dense
                      required
                      :rules="farmRules.govRegistrationNo"
                      v-model="farm.govRegistrationNum"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" sm="6" md="3">
                    <label>{{ $t("farm.contractMating") }}</label>
                    <v-text-field
                      :placeholder="$t('farm.contractMating')"
                      outlined
                      dense
                      v-model="farm.contractMating"
                    ></v-text-field>
                  </v-col> -->

                  <!-- <v-col cols="12" sm="6" md="3">
											<label>{{$t('farm.contractMating')}}<span>*</span></label>
											<v-text-field
												:placeholder="$t('farm.contractMating')"
												outlined
												dense
												v-model="farm.contractMating"
												:error-messages="errors.contractMating"
												:rules="farmRules.contractMating"
											></v-text-field>
										</v-col> -->

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("Farming System") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >Types of farming system should be chosen depending
                          upon the geographical and local climatic conditions
                          with keeping economics in mind. E.g. Loose Farming,
                          Conventional barn system and free range system.</span
                        >
                      </v-tooltip>
                    </label>
                    <v-select
                      :items="farmProductionSystems"
                      :placeholder="'Select'"
                      outlined
                      dense
                      class="text-capitalize"
                      item-text="name"
                      item-value="id"
                      v-model="farm.productionSystem"
                      multiple
                    >
                    </v-select>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-show="farm.farmOwnershipType == 'corporate'"
                  >
                    <label
                      >{{ $t("cooperativeId") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >Cooperative ID refers to a unique identifier or code
                          assigned to a cooperative or union.</span
                        >
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :placeholder="'e.g. 34.4652342137'"
                      outlined
                      dense
                      v-model="farm.cooperativeId"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-show="farm.farmOwnershipType == 'corporate'"
                  >
                    <label
                      >{{ $t("farm.cooperativeName") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t(
                            "This refers to the name of a cooperative or union, which is an organization formed by farmers or producers who come together to collectively market and sell their agricultural products or to achieve common goals in production, processing, or distribution."
                          )
                        }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="'Enter Name'"
                      outlined
                      dense
                      v-model="farm.cooperativeName"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.houseNumber") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.houseNumberH") }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="$t('farm.houseNumber')"
                      outlined
                      dense
                      v-model="farm.houseNum"
                      :rules="farmRules.houseNo"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.goals') }}
											<v-tooltip right color="black" max-width="320">
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
												</template>
												<span>Types of farming system should be chosen depending upon the geographical and local
													climatic conditions with keeping economics in mind. E.g. Loose Farming, Conventional barn
													system and free range system.</span>
											</v-tooltip>
										</label>
										<v-select :items="goalOptions" :placeholder="'Select'" outlined dense
											class="text-capitalize" item-text="name" item-value="id" v-model="farm.goal">
										</v-select>
									</v-col> -->
                </v-row>
              </template>
            </v-container>
          </v-card>
          <v-card class="mt-5 mb-5" flat>
            <v-container fluid>
              <div class="font-weight-bold">
                {{ $t("farm.farmLicenseInformation") }}
              </div>
              <template>
                <v-row class="mt-2">
                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.licenseNumber") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span>{{ $t("farm.registration.licenseNumber") }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="'LN3872390'"
                      outlined
                      v-model="farm.licenceNum"
                      dense
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.licenseExpiryDate") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span>{{
                          $t("farm.registration.licenseExpiryDate")
                        }}</span>
                      </v-tooltip></label
                    >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      dense
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="farm.licenceExpiryDate"
                          placeholder="Choose the date"
                          append-icon="mdi-calendar"
                          outlined
                          readonly
                          dense
                          v-bind="attrs"
                          v-on="on"
                          v-on:click:append="menu = true"
                          :error-messages="errors.licenceED"
                          :rules="farmRules.licenceED"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="farm.licenceExpiryDate"
                        no-title
                        scrollabel
                        :min="new Date().toISOString().substr(0, 10)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          {{ $t("farm.cancel") }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(farm.licenceExpiryDate)"
                        >
                          {{ $t("farm.ok") }}
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.regulatorName") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span>{{ $t("farm.registration.regulatorName") }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :placeholder="$t('Uganda Govt.')"
                      outlined
                      dense
                      v-model="farm.regulatorName"
                    >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.regulatorRepresentativeName")
                      }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span>{{
                          $t("farm.registration.regulatorRepresentativeName")
                        }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="$t('John Smith')"
                      outlined
                      dense
                      required
                      v-model="farm.regulatorRepresentiveName"

                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>
            </v-container>
          </v-card>

          <v-card class="mt-5 mb-5" flat>
            <v-container fluid>
              <!-- <v-alert :outlined="geofenceValidation" :color="geofenceValidation ? 'red' : ''" fluid class="pb-10"> -->
              <div class="font-weight-bold mb-7">
                {{ $t("farm.farmLocationSize") }}
              </div>
              <template>
                <v-row class="mt-5">
                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("Farm Location Address") }}<span>*</span>

                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.farmLocationAddressInfo") }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :rules="farmRules.address"
                      readonly
                      @click="showFarmLocation = true"
                      id="dialog-link1"
                      :placeholder="$t('clickChooseLocation')"
                      outlined
                      dense
                      v-model="farm.address"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.country") }} <span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.countryH") }}</span>
                      </v-tooltip></label
                    >
                    <v-select
                      :items="country"
                      :placeholder="$t('farm.country')"
                      outlined
                      item-text="name"
                      dense
                      :loading="countryLoading"
                      v-model="farm.country"
                      item-value="name"
                      :rules="farmRules.country"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("Province/State") }}<span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.provinceStateInfo") }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :placeholder="$t('enterHere')"
                      outlined
                      required
                      dense
                      v-model="farm.state"
                      :rules="farmRules.state"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.city") }}<span>*</span>
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.cityInfo") }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :placeholder="$t('enterHere')"
                      outlined
                      required
                      dense
                      v-model="farm.city"
                      :rules="farmRules.city"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("Street Number") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("farm.streetNumberInfo") }}</span>
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :placeholder="$t('kabale-kisoro Road')"
                      outlined
                      dense
                      v-model="farm.street"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" sm="6" md="3">
										<label>{{ $t('farm.postal') }} </label>
										<v-text-field :placeholder="$t('farm.postal')" outlined dense v-model="farm.street"></v-text-field>
									</v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.farmNumber") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >The postal Number of farm similar to House
                          number.</span
                        >
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :placeholder="$t('farm.farmNumber')"
                      outlined
                      dense
                      v-model="farm.farmNumber"
                    ></v-text-field>
                  </v-col> -->

                  <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.farmNumber") }}
                      <v-tooltip right color="black" max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >The postal Number of farm similar to House
                          number.</span
                        >
                      </v-tooltip>
                    </label>
                    <v-text-field
                      :placeholder="$t('farm.farmNumber')"
                      outlined
                      dense
                      v-model="farm.farmNumber"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-row no-gutters class="d-flex">
                      <v-col cols="6" class="pr-1">
                        <label style="font-size: 0.8em"
                          >{{ $t("farm.totalFarmSize") }} <span>*</span></label
                        >
                        <v-tooltip top color="black" max-width="220">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("farm.totalFarmSizeInfo") }}</span>
                        </v-tooltip>
                        <v-text-field
                          v-model="farm.area"
                          :placeholder="$t('e.g. 12 Hectors')"
                          outlined
                          required
                          dense
                          :rules="farmRules.farmSize"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <label>{{ $t("Unit") }}</label>
                        <v-tooltip top color="black" max-width="220">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("farm.areaUOMInfo") }}</span>
                        </v-tooltip>

                        <v-select
                          :items="farmUnits"
                          :placeholder="$t('select')"
                          v-model="farm.areaUomId"
                          outlined
                          class="text-capitalize"
                          item-text="name"
                          item-value="id"
                          dense
                          @change="changeAreaUnit"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="3">
                    <v-row no-gutters class="d-flex">
                      <v-col cols="6" class="pr-1">
                        <label>{{ $t("farm.perimeterLength") }} </label>
                        <v-tooltip top color="black" max-width="220">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("farm.perimeterLengthInfo") }}</span>
                        </v-tooltip>
                        <v-text-field
                          :placeholder="$t('farm.perimeterLength')"
                          outlined
                          dense
                          v-model="farm.parameter"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <label>{{ $t("Unit") }}</label>
                        <v-tooltip top color="black" max-width="220">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("farm.permiterUOMInfo") }}</span>
                        </v-tooltip>
                        <v-select
                          v-model="farm.parameterUomId"
                          :items="periUni"
                          item-text="name"
                          item-value="id"
                          class="text-capitalize"
                          placeholder="Select"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-col> -->
                  <!-- <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.perimeterPointLabel") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("farm.registration.perimeterPointLabel")
                        }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="$t('farm.perimeterPointLabel')"
                      outlined
                      dense
                      v-model="farm.periPointLabel"
                    ></v-text-field>
                  </v-col> -->
                  <!-- <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.perimeterPointLatitude") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("farm.registration.perimeterPointLatitude")
                        }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="$t('farm.perimeterPointLatitude')"
                      outlined
                      dense
                      v-model.number="farm.periPointLat"
                      :rules="[
                        (v) => !v || validateLatLng(v) || 'Invalid Latitude',
                      ]"
                    ></v-text-field>
                  </v-col> -->
                  <!-- <v-col cols="12" sm="6" md="3">
                    <label
                      >{{ $t("farm.perimeterPointLongitude") }}
                      <v-tooltip top color="black" max-width="220">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("farm.registration.perimeterPointLongitude")
                        }}</span>
                      </v-tooltip></label
                    >
                    <v-text-field
                      :placeholder="$t('farm.perimeterPointLongitude')"
                      outlined
                      dense
                      v-model.number="farm.periPointLng"
                      :rules="[
                        (v) => !v || validateLatLng(v) || 'Invalid Longitude',
                      ]"
                    ></v-text-field>
                  </v-col> -->
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-btn
                      color="primary"
                      dark
                      depressed
                      outlined
                      @click="showGeofenceTool"
                    >
                      {{ $t("ADD GEOFENCE FOR THIS FARM") }}
                    </v-btn>
                    <!-- <p class="mt-2 red--text">Note: Geofence is required for Satellite Reports and to add zones.</p> -->
                  </v-col>
                </v-row>
                <div
                  v-if="!farm.area || !farm.farmGeofence.length"
                  class="ml-2 mt-2"
                  style="font-size: 0.6em; color: rgb(255, 18, 18)"
                >
                  Note: Geofence is Required for Satellite Reports
                </div>
              </template>

              <!-- </v-alert> -->
            </v-container>
          </v-card>
        </div>
      </v-form>
    </v-container>
    <add-user
      v-if="showCreateUserDialog"
      @userAdded="userAdded"
      @closeAddUser="showCreateUserDialog = false"
      :dialogI="showCreateUserDialog"
    ></add-user>
    <prompt-dialog
      @closeDialog="showPromptDialog = false"
      @saveData="saveFormData"
      :dialogI="showPromptDialog"
      v-if="showPromptDialog"
    />
    <primary-geofence
      v-if="showMap"
      :showMap="showMap"
      :farm="farm"
      @close-location-modal="locationMapClosed"
      @close-without-change="closeWithoutChange"
    ></primary-geofence>

    <FarmLocation
      v-if="showFarmLocation"
      :showMap="showFarmLocation"
      :farm="farm"
      @close-location-modal="farmLocationClosed"
      @close-without-change="closeWithoutChange"
    />
    <DataLostWarning
      :dialogI="dataLossWarning"
      v-if="dataLossWarning"
      @closeDialog="closeWarningMessage"
      @saveData="closeWarningMessage"
    ></DataLostWarning>
  </div>
</template>

<script>
import AddUser from "@/views/user/AddUser";
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import { farmRules } from "@/validations/FarmFormRules.js";
// import countries from "@/constants/countries.js";
import generalMixin from "@/mixins/GeneralMixin";
import PrimaryGeofence from "./PrimaryGeofence.vue";
import FarmLocation from "./FarmLocation.vue";
import gql from "graphql-tag";
import { users, farmersList } from "@/graphql/Users.gql";
import PromptDialog from "../common/PromptDialog.vue";
import {
  getFarmById,
  updateFarm,
  getFarmFormOptions,
  country,
} from "@/graphql/Farm.gql";

export default {
  apollo: {
    users: {
      query: users,
      update: (data) => {
        console.log(data, "data");
        return data.users;
      },
    },
    farmersList: {
      query: farmersList,
      result({ data }) {
        this.farmerItems = data.farmersList;
      },
    },
    getFarmFormOptions: {
      query: getFarmFormOptions,
      update: (data) => data.getFarmFormOptions,
      fetchPolicy: "no-cache",
      variables() {
        return {};
      },
      result({ data }) {
        const farmType = data.getFarmFormOptions.find(
          (farmType) => farmType.groupName == "FarmTypes"
        );
        this.farmTypes = farmType.options;

        // this.ownershipTypes = options['farm-ownership-type'];
        const productionSystem = data.getFarmFormOptions.find(
          (farmType) => farmType.groupName == "FarmProductionSystem"
        );
        this.farmProductionSystems = productionSystem.options;
        this.loading = false;
        console.log("AVAILABLE QUICK FILTER", data);
      },
    },
    country: {
      query: country,
      update: (data) => data.country,
      fetchPolicy: "no-cache",
      variables() {
        return {};
      },
      result({ data }) {
        // debugger;
        this.countries = data.country;
      },
    },
  },
  computed: {
    currentUser() {
      return this.$store.getters.getUser;
    },
    farmers() {
      return this.users.map((u) => {
        u.fullName = `${u.firstName} ${u.lastName}`;
        return u;
      });
    },
    hasChanged() {
      return true;
    },
  },
  watch: {
    farm: {
      handler() {
        this.formChanged = true;
      },
      deep: true,
    },
    "farm.farmOwnershipType": function (nV) {
      if (nV == "personal") {
        this.farm.communityName = "";
        this.farm.corporateName = "";
        this.farm.corporateRegistrationNum = "";
        this.farm.corporateMailingAddress = "";
      } else if (nV == "community") {
        this.farm.corporateName = "";
        this.farm.corporateRegistrationNum = "";
        this.farm.corporateMailingAddress = "";
      } else if (nV == "corporate") {
        this.farm.communityName = "";
      }
    },
    "farm.parameterUomId": {
      handler: function (newVal) {
        // Changes detected. Do work...
        this.farm.areaUomId = newVal;
      },
      deep: true,
    },
  },
  async mounted() {
    console.log(this.$store.getters.getUser);
    this.farm.userId = parseInt(this.$store.getters.getUser.userDetail.id);
    // const options = await FarmService.getFarmOptions();
    // this.farmTypes = options.FarmTypes;
    // // this.ownershipTypes = options['farm-ownership-type'];
    // this.farmProductionSystems = options.FarmProductionSystem;

    if (this.$route.params?.farmId) {
      this.startLoading();
      this.getFarmDetailForEdit();
    }
  },
  components: {
    "add-user": AddUser,
    breadcrumb: Breadcrumb,
    PrimaryGeofence,
    "prompt-dialog": PromptDialog,
    FarmLocation,
  },
  data() {
    return {
      submitted: false,
      showCreateUserDialog: false,
      farmerItems: [],
      dataLossWarning: false,
      showFarmLocation: false,
      geofenceValidation: false,
      addManually: false,
      users: [],
      countries: [],
      farmProductionSystems: [],
      farmTypes: [],
      ownershipTypes: [
        { id: "personal", name: "Personal" },
        { id: "community", name: "Community" },
        { id: "corporate", name: "Corporate" },
      ],
      showMap: false,
      menu: "",
      error: false,
      countryLoading: false,
      stateLoading: false,
      cityLoading: false,
      errors: {
        name: "",
        farmType: "",
        farmownershipType: "",
        ownerName: "",
        govRegistrationNum: "",
        contractMating: "",
        productionSystemOptId: "",
        regulatorRepresentiveName: "",
        cooperativeID: "",
        licenceNumber: "",
        licenceED: "",
        regulatorName: "",
        lat: "",
        log: "",
      },
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("farm.farms"),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "My farm" },
        },
        {
          text: this.$t("farm.registerAfarm"),
          disabled: true,
        },
      ],
      farm: {
        userId: null,
        farmNumber: "",
        farmName: "",
        registrationNo: "",
        lat: 0,
        log: 0,
        address: "",
        area: "",
        areaUomId: 0,
        parameter: 0,
        parameterUomId: 0,
        farmOwnershipType: "personal",
        farmGeofence: [],
        farmType: null,
        productionSystem: null,
        farmOwner: null,
        country: "",
        state: "",
        city: "",
        govRegistrationNum: "",
        contractMating: "",
        cooperativeId: "",
        licenceNum: "",
        licenceExpiryDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        regulatorName: "",
        houseNum: "",
        street: "",
        regulatorRepresentiveName: "",
        communityName: "",
        corporateName: "",
        corporateRegistrationNum: "",
        corporateMailingAddress: "",
        // goal: "",
      },
      // countryId: 101,
      // stateId: 4022,
      // farmType: [],
      // farmownershipType: [],
      // productionSystem: [],
      // res: [],
      farmUnits: [
        { id: 1, name: "Acre" },
        { id: 2, name: "Hectare" },
      ],
      periUni: [
        { id: 1, name: "Acre" },
        { id: 2, name: "hectare" },
      ],
      farmRules,
      valid: true,
      // country: [],
      // state: [],
      // city: [],
      // users:[],
      showPromptDialog: false,
      promptToRoute: null,
      promptNextRoute: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.formChanged && !this.submitted) {
      this.promptToRoute = to;
      this.dataLossWarning = true;
      return;
    }
    next();
  },
  methods: {
    async userAdded(res) {
      if (res.success) {
        this.$notify({
          title: this.$t("user.userAdded"),
          text: res.message,
          type: "success",
          duration: 10000,
        });
        await this.$apollo.queries.farmersList.refetch();
        this.farm.farmOwner = Number(res.userObj.data.createUser.id);
      } else {
        this.$notify({
          title: this.$t("user.userNotAdded"),
          text: res.message.message.replace("GraphQL error:", ""),
          type: "error",
          duration: 10000,
        });
      }
    },
    showAdduser() {
      this.showCreateUserDialog = true;
    },
    async getFarmDetailForEdit() {
      const farmId = this.$route.params?.farmId;

      const response = await this.$apollo.query({
        query: getFarmById,
        fetchPolicy: "no-cache",
        variables: {
          farmId: Number(farmId),
        },
      });
      this.stopLoading();
      this.farm = response.data.getFarmById;
      this.farm.productionSystem = JSON.parse(this.farm.productionSystem);
      this.farm.userId = parseInt(this.$store.getters.getUser.userDetail.id);
      // this.farm.id = Number(this.farm.id);
      // this.farm.farmType = Number(this.farm.farmType);
      // this.farm.cityId = this.farm.cityId.toString();
      // this.farm.stateId = this.farm.stateId.toString();
      // this.farm.countryId = this.farm.countryId.toString();
      // this.countryId = this.farm.countryId;

      delete this.farm.createdAt;
      delete this.farm.__typename;

      this.getStates(this.countryId);
      this.getCity(this.farm.stateId);
    },
    validateLatLng(latLng) {
      var reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\\.{1}\\d{1,6}");
      if (reg.exec(latLng)) {
        return true;
      } else {
        return false;
      }
    },
    showGeofenceTool() {
      if (this.farm.address !== "") {
        this.showMap = true;
      } else {
        this.$notify({
          text: "Farm Location is required.",
          type: "error",
        });
      }
    },
    farmLocationClosed(data) {
      console.log("farmLocationClosed", data);
      this.showFarmLocation = false;
      this.farm.lat = data.lat;
      this.farm.log = data.log;
      this.farm.address = data.address;
      this.farm.country = data.addressData.country;
      this.farm.city = data.addressData.locality;
      this.farm.state = data.addressData.administrative_area_level_1;
      //this.farm.street = data.addressData.street_number
      this.farm.street = data.addressData.route;
    },
    changeAreaUnit() {
      if (this.farm.areaUomId === 1) {
        this.farm.area = parseFloat(this.farm.area * 2.47105).toFixed(5);
      } else {
        this.farm.area = parseFloat(this.farm.area / 2.47105).toFixed(5);
      }
      this.farm.parameterUomId = this.farm.areaUomId;
    },
    locationMapClosed(gdata) {
      console.log(gdata, "locationMapClosed");

      this.geofenceValidation = false;
      this.addManually = true;
      this.showMap = false;
      this.farm.lat = gdata.lat;
      this.farm.log = gdata.log;
      this.farm.address = gdata.address;
      this.farm.coordinates = gdata.farmGeofence;
      this.farm.farmGeofence = gdata.farmGeofence;
      this.farm.area = `${gdata.area}`;
      this.farm.parameter = +gdata.parameter;
      this.farm.areaUomId = gdata.areaUomId;
      this.farm.country = gdata.addressData.country;
      this.farm.city = gdata.addressData.locality;
      this.farm.state = gdata.addressData.administrative_area_level_1;
      //this.farm.street = gdata.addressData.street_number
      this.farm.street = gdata.addressData.route;
    },
    closeWithoutChange() {
      this.showMap = false;
      this.showFarmLocation = false;
      // this.geofenceValidation = true
    },
    // loadOptions() {
    //   const options = {
    //     options: ["production-system", "farm-ownership-type", "farm-type"],
    //   };
    //   FarmService.loadoptions(options).then((data) => {
    //     let newdata = data.data["production-system"];
    //     this.productionSystem = newdata;
    //     let ownerdata = data.data["farm-ownership-type"];
    //     this.farmownershipType = ownerdata.map((item) => item.name);
    //     let farmdata = data.data["farm-type"];
    //     this.farmType = farmdata.map((item) => item.name);
    //   });
    // },
    registerFarm() {
      this.formChanged = false;
      this.showPromptDialog = false;
      this.promptNextRoute = true;
      // if (!this.farm.country) {
      // 	this.geofenceValidation = true
      // 	const element = document.getElementById("geofenceSection")
      // 	if (this.farm.farmName && this.farm.farmOwner) {
      // 		element.scrollIntoView({ behavior: "smooth" })
      // 	}
      // 	this.$notify({
      // 		title: "Add Farm Geofence data",
      // 		text: 'click USE GEOFENCE TOOL',
      // 		type: "error",
      // 	});
      // }
      if (!this.$refs.form.validate()) return;
      this.farm["parameter"] = +this.farm.parameter;
      // if (this.farm.address == '' || !this.farm.farmGeofence || this.farm.farmGeofence.length < 1) {

      // 	this.$notify({
      // 		title: "Add Farm Geofence data",
      // 		text: 'click USE GEOFENCE TOOL',
      // 		type: "error",
      // 	});
      // 	return;
      // }
      delete this.farm.coordinates;
      this.startLoading();
      if (this.$route?.params?.farmId) {
        delete this.farm.FarmCoordinates;
        this.farm.id = Number(this.farm.id);
        this.farm.farmOwner= Number(this.farm.farmOwner);
        this.$apollo
          .mutate({
            mutation: updateFarm,
            variables: {
              updateFarmInput: this.farm,
            },
          })
          .then(() => {
            // debugger;
            this.stopLoading();
            this.$notify({
              title: `Farm updated successfully`,
              text: "success",
              type: "success",
              position: "top right",
            });
          })
          .catch((e) => {
            console.log(e);
            this.stopLoading();
            this.$notify({
              title: `Farm cannot be added.`,
              text: "Something went wrong!",
              type: "error",
              position: "top right",
            });
          });

        this.$router.push({ name: "FarmLists", query: { page: 1 } });
      } else {
        this.submitted = true // to avoid showing the leave or stay prompt
        if(!this.farm.farmOwner) {
          this.farm.farmOwner = Number(this.currentUser.userDetail.id)
        }
        this.$apollo
          .mutate({
            mutation: gql`
              mutation createFarm($data: CreateFarmInput!) {
                createFarm(createFarmInput: $data) {
                  id
                }
              }
            `,
            variables: {
              data: this.farm,
            },
          })
          .then(() => {
            this.stopLoading();
            this.$notify({
              title: `Farm added successfully`,
              text: "success",
              type: "success",
              position: "top right",
            });
            this.$router.push({ name: "FarmLists" });
          })
          .catch((e) => {
            console.log(e);
            this.stopLoading();
            this.$notify({
              title: `Farm cannot be added.`,
              text: "Something went wrong!",
              type: "error",
              position: "top right",
            });
          });
      }
    },
    saveFormData(answer) {
      this.showPromptDialog = false;
      if (!answer) {
        this.promptNextRoute = true;
        this.$router.push(this.promptToRoute);
      }
    },
    closeWarningMessage(stay) {
      this.dataLossWarning = false;
      if (!stay) {
        this.formChanged = false;
        this.$router.push(this.promptToRoute);
      }
    },
  },
  mixins: [loadingMixin, generalMixin],
  // beforeRouteLeave(to, from, next) {
  //   if (this.promptNextRoute) {
  //     next();
  //   } else {
  //     if (this.hasChanged) {
  //       this.promptToRoute = to;
  //       this.showPromptDialog = true;
  //     } else {
  //       next();
  //     }
  //   }
  // },
};
</script>

<style>
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}

.button {
  float: right;
}

.v-btn {
  margin-right: 5px;
}

.route {
  text-decoration: none !important;
}

.form-group {
  margin-top: -20px;
}

.form-section label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.form-section label span {
  color: red;
}

.v-list-item__title {
  text-transform: capitalize;
}

#dialog-link1 {
  cursor: pointer !important;
}

#dialog-link1::placeholder {
  color: #002287 !important;
  text-decoration: underline !important;
}
</style>
